import React from 'react';
import ContactForm from './ContactForm';
import OfficeLocations from './OfficeLocations';
import { useContactForm } from '../hooks/useContactForm';

const Contact = () => {
  const { formData, loading, handleChange, handleSubmit } = useContactForm();

  return (
    <section id="contact" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Contact Us
          </h2>
          <div className="w-20 h-1 bg-cyan-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Get in touch with us to discuss your project requirements
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <ContactForm
            formData={formData}
            loading={loading}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />

          {/* Office Locations */}
          <OfficeLocations />
        </div>
      </div>
    </section>
  );
};

export default Contact;